import { useState, createContext } from "react";
import {
  About,
  LngBtn,
  Contacts,
  Container,
  Experience,
  Footer,
  Header,
  Portfolio,
  Skills,
} from "./components/commons";
import { User, userEn, userPl, userUa } from "./service/data";

export const AppContext: React.Context<{
  userInfo?: User;
  lang?: "en" | "pl" | "ua",
}> = createContext({});

function App() {
  const [lang, setLang] = useState<"en" | "pl" | "ua">("pl");
  const [experienceStart, setExperience] = useState(false);

  const changeLang = (lng: "en" | "pl" | "ua") => {
    if (lng !== lang) {
      setLang(lng);
    }
  };

  const scrollHandler = (e: any) => {
    const setheight = 200;
    const sectionHeight = 200;

    const topHeight = e.nativeEvent.srcElement.scrollTop;

    if (topHeight > setheight + sectionHeight) {
      !experienceStart && setExperience(true);
    }
  };

  return (
    <AppContext.Provider
      value={
        lang === "pl"
          ? { userInfo: userPl, lang }
          : lang === "en"
            ? { userInfo: userEn, lang }
            : { userInfo: userUa, lang }
      }
    >
      <div className="wrapper" onScroll={scrollHandler}>
        <Header />
        <Container>
          <>
            <About />
            <Skills />
            <Experience start={experienceStart} />
            <Portfolio />
            <Contacts />
          </>
        </Container>
        <Footer />
        <LngBtn
          value={lang}
          className={"toggle-language_btn"}
          onChange={(lng) => changeLang(lng)}
        />
      </div>
    </AppContext.Provider>
  );
}

export default App;
